import { briefingTimeline } from "@/mocks/portalData";

export default function Briefing() {
  return (
    <section id="briefing" className="bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 px-4 md:px-6 lg:grid-cols-2">
        <div>
          <p className="text-sm font-medium text-primary-600">实时简报 · BRIEFING</p>
          <h2 className="mt-1 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
            爆料速递时间线
          </h2>
          <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
            以时间线形式还原今天的热点推进节奏，帮助你在碎片时间里快速跟上事件进度。
          </p>

          <ol className="mt-8 space-y-0 border-l-2 border-primary-200 pl-5">
            {briefingTimeline.map((t) => (
              <li key={t.time} className="relative pb-6 last:pb-0">
                <span className="absolute -left-[27px] top-1 h-3.5 w-3.5 rounded-full border-2 border-background-50 bg-primary-500"></span>
                <div className="flex items-center gap-3">
                  <span className="whitespace-nowrap rounded-md bg-background-50 px-2 py-0.5 font-heading text-xs font-bold text-primary-700">
                    {t.time}
                  </span>
                </div>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-700">{t.text}</p>
              </li>
            ))}
          </ol>
        </div>

        <div className="flex flex-col">
          <div className="overflow-hidden rounded-2xl">
            <img
              src="https://readdy.ai/api/search-image?query=abstract%20newsroom%20with%20breaking%20headlines%20projected%20on%20screens%2C%20warm%20crimson%20ambient%20light%2C%20editorial%20journalism%20concept%2C%20cinematic%20and%20premium%20magazine%20style&width=1200&height=900&seq=newsroom-brief-2026&orientation=portrait"
              alt="爆闻站编辑部实时跟进全网话题动态的抽象场景"
              className="h-64 w-full object-cover md:h-80"
              width={1200}
              height={900}
            />
          </div>
          <div className="mt-4 rounded-xl border border-background-200/70 bg-background-50 p-5">
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-accent-500 text-background-50">
                <i className="ri-compasses-2-line text-base"></i>
              </span>
              <h3 className="font-heading text-base font-bold text-foreground-950">编辑立场声明</h3>
            </div>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              本平台仅做信息聚合与来源索引，不对任何事件下结论。请理性看待所有爆料内容，事件真实性以当事方与权威信息为准。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}